/** Fixed-point helpers. Math.sin/cos/sqrt precision may differ between engines, so we use tables and integers. */

export const TRIG_ONE = 16384;

// Math.round(Math.sin(deg * PI / 180) * 16384) for deg = 0..90, precomputed once and frozen here.
const SIN_Q14: readonly number[] = [
  0, 286, 572, 857, 1143, 1428, 1713, 1997, 2280, 2563, 2845, 3126, 3406, 3686, 3964, 4240, 4516, 4790,
  5063, 5334, 5604, 5872, 6138, 6402, 6664, 6924, 7182, 7438, 7692, 7943, 8192, 8438, 8682, 8923, 9162,
  9397, 9630, 9860, 10087, 10311, 10531, 10749, 10963, 11174, 11381, 11585, 11786, 11982, 12176, 12365,
  12551, 12733, 12911, 13085, 13255, 13421, 13583, 13741, 13894, 14044, 14189, 14330, 14466, 14598,
  14726, 14849, 14968, 15082, 15191, 15296, 15396, 15491, 15582, 15668, 15749, 15826, 15897, 15964,
  16026, 16083, 16135, 16182, 16225, 16262, 16294, 16322, 16344, 16362, 16374, 16382, 16384,
];

/** sin of an integer angle in degrees, scaled by TRIG_ONE. */
export function sinDeg(deg: number): number {
  const d = ((deg % 360) + 360) % 360;
  if (d <= 90) return SIN_Q14[d];
  if (d <= 180) return SIN_Q14[180 - d];
  if (d <= 270) return -SIN_Q14[d - 180];
  return -SIN_Q14[360 - d];
}

export function cosDeg(deg: number): number {
  return sinDeg(deg + 90);
}

/** floor(sqrt(n)) for non-negative integers. */
export function isqrt(n: number): number {
  if (n <= 0) return 0;
  let x = n;
  let y = Math.floor((x + 1) / 2);
  while (y < x) {
    x = y;
    y = Math.floor((x + Math.floor(n / x)) / 2);
  }
  return x;
}
